import { api } from './api';

export const messagesService = {
  getSystemChats: async () => {
    const { data } = await api.get('/admin/messages');
    return data;
  },

  getChatMessagesById: async (chatId) => {
    const { data } = await api.get(`/admin/messages/chat/${chatId}`);
    return data;
  },

  getChatByUser: async (userId) => {
    const { data } = await api.get(`/admin/messages/user/${userId}`);
    return data;
  },

  sendAdminMessage: async (chatId, content) => {
    const { data } = await api.post(`/admin/messages/chat/${chatId}`, {
      content,
    });
    return data;
  },

  // первый месседж от админа, когда системного чата ещё нет
  sendAdminFirstMessageToUser: async (userId, content) => {
    const { data } = await api.post(`/admin/messages/user/${userId}`, {
      content,
    });
    return data;
  },
};

